import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const useHasServiceDeskAccess = (): boolean => useApplicationPermissions().hasServiceDeskAccess;

export const useCanAccessOperations: () => boolean = functionWithCondition(
	() => fg('operations_sidebar_require_jsm_access'),
	useHasServiceDeskAccess,
	() => true,
);
